import React, { useState } from 'react';
import ReactDOM from 'react-dom';

const Chefs = () => {
    const root = document.querySelector('#render-react-chefs');

    const chef1_name = root.getAttribute('data-chef1-name') || 'Dustin';
    const chef2_name = root.getAttribute('data-chef2-name') || 'Paul';
    const chef1_img = root.getAttribute('data-chef1-img') || 'https://example.com/chef1.webp';
    const chef2_img = root.getAttribute('data-chef2-img') || 'https://example.com/chef2.webp';
    const chef1_copy = root.getAttribute('data-chef1-copy') || '<p>Default Chef 1 description.</p>';
    const chef2_copy = root.getAttribute('data-chef2-copy') || '<p>Default Chef 2 description.</p>';

    const chef1 = {
        name: chef1_name,
        img: chef1_img,
        copy: chef1_copy,
    };
    const chef2 = {
        name: chef2_name,
        img: chef2_img,
        copy: chef2_copy,
    };

    const [activeChef, setActiveChef] = useState(null);
    const [showState, setShowState] = useState(false);

    const handleChefClick = (chef) => {
        setActiveChef(chef);
        setShowState(true);
    };

    return (
        <div className={showState ? 'meet-chef__wrapper meet-chef__wrapper--shift' : 'meet-chef__wrapper'}>
            <div className="meet-chef__title">
                <h2>
                    Meet Chef {chef1_name} &amp; Chef {chef2_name}
                </h2>
                <p>Click on each Chef to find out more about them!</p>
            </div>
            <div className="meet-chef__image">
                <figure className="chef1">
                    <img src={chef1_img} onClick={() => handleChefClick(chef1)} alt={`Chef ${chef1_name}`} />
                    <figcaption>Chef {chef1_name}</figcaption>
                </figure>
                <figure className="chef2">
                    <img src={chef2_img} onClick={() => handleChefClick(chef2)} alt={`Chef ${chef2_name}`} />
                    <figcaption>Chef {chef2_name}</figcaption>
                </figure>
            </div>
            <div className={showState ? 'meet-chef__copy' : 'meet-chef__copy meet-chef__copy--hide'}>
                {showState && activeChef && (
                    <>
                        <h3>Chef {activeChef.name}</h3>
                        <div dangerouslySetInnerHTML={{ __html: activeChef.copy }}></div>
                    </>
                )}
            </div>
        </div>
    );
};

document.addEventListener('DOMContentLoaded', () => {
    const rootElement = document.getElementById('render-react-chefs');
    console.log('rootElement',rootElement);
    if (rootElement) {
        console.log('render');
        ReactDOM.render(<Chefs />, rootElement);
    }
});
